/**
 * 'ElementUi'
 * Import elements from Element UI
 *
 * @see http://element.eleme.io/#/en-US/component/quickstart
 * @version 1.0.0
 * @author Fernando Torres
 * @copyright Marciano Studio S.C., 2018
 */

import Vue from 'vue'
import locale from 'element-ui/lib/locale'
import lang from 'element-ui/lib/locale/lang/es'
import {
  Autocomplete,
  Badge,
  Container,
  DatePicker,
  Dialog,
  Row,
  Radio,
  RadioGroup,
  RadioButton,
  Header,
  Col,
  Button,
  Form,
  Footer,
  FormItem,
  Input,
  Switch,
  Step,
  Steps,
  Loading,
  MessageBox,
  Notification,
  Message,
  Menu,
  Submenu,
  MenuItem,
  MenuItemGroup,
  Select,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  Option,
  OptionGroup,
  Breadcrumb,
  BreadcrumbItem,
  ButtonGroup,
  Card,
  Popover,
  Progress,
  Collapse,
  CollapseItem,
  Tabs,
  TabPane,
  Table,
  TableColumn,
  Tag,
  Upload,
  Checkbox,
  CheckboxButton,
  CheckboxGroup,
  TimeSelect,
  Alert,
  TimePicker
} from 'element-ui'

Vue.use(Autocomplete)
Vue.use(Badge)
Vue.use(Container)
Vue.use(Row)
Vue.use(Radio)
Vue.use(RadioButton)
Vue.use(RadioGroup)
Vue.use(Col)
Vue.use(DatePicker)
Vue.use(Header)
Vue.use(Button)
Vue.use(Form)
Vue.use(Footer)
Vue.use(FormItem)
Vue.use(Input)
Vue.use(Switch)
Vue.use(Step)
Vue.use(Steps)
Vue.use(Select)
Vue.use(Menu)
Vue.use(Submenu)
Vue.use(MenuItem)
Vue.use(MenuItemGroup)
Vue.use(Dropdown)
Vue.use(DropdownItem)
Vue.use(DropdownMenu)
Vue.use(Dialog)
Vue.use(Option)
Vue.use(OptionGroup)
Vue.use(Breadcrumb)
Vue.use(BreadcrumbItem)
Vue.use(ButtonGroup)
Vue.use(Popover)
Vue.use(Progress)
Vue.use(Loading.directive)
Vue.use(Card)
Vue.use(Collapse)
Vue.use(CollapseItem)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Tag)
Vue.use(Upload)
Vue.use(CheckboxButton)
Vue.use(CheckboxGroup)
Vue.use(Checkbox)
Vue.use(TimeSelect)
Vue.use(Alert)
Vue.use(TimePicker)
Vue.use(Loading.directive)
locale.use(lang)

Vue.prototype.$loading = Loading.service
Vue.prototype.$msgbox = MessageBox
Vue.prototype.$alert = MessageBox.alert
Vue.prototype.$confirm = MessageBox.confirm
Vue.prototype.$prompt = MessageBox.prompt
Vue.prototype.$notify = Notification
Vue.prototype.$message = Message



// WEBPACK FOOTER //
// ./src/config/element-ui.config.js